const options = [
    {
        'name': 'Deposit Only',
        'code': 'free',
        'value': 'Free',
        'pricing': 'FREE',
        'features': [

        ]
    },
    {
        'name': 'Pay as you go',
        'code': 'payg',
        'value': '$2.99 / month',
        'pricing': 'FREE',
        'features': [
            {
                label: 'Sending Bank Accounts',
                value: '$5.00/mo.'
            },
            {
                label: 'vCheck Transaction Fee',
                value: '$1.00/ea.'
            },
            {
                label: 'Bill Payment Surcharge',
                value: '$0.35/ea.'
            },
            {
                label: 'Users',
                value: 'UNLIMITED'
            },
            {
                label: 'Auto Deposit'
            },
            {
                label: 'Review & Approve Checks',
            },
            {
                label: 'Auto-Sign Checks',
            }
        ]
    },
    {
        'name': 'Enterprise',
        'code': 'enterprise',
        'value': '',
        'pricing': '',
        'features': [
            {
                label: 'All PAYG Plan Features',
                value: ''
            },
            {
                label: 'Sending Bank Accounts',
                value: 'contact us'
            },
            {
                label: 'vCheck Transaction Fee',
                value: ''
            },
            {
                label: 'Bill Payment Surcharge',
                value: ''
            },
            {
                label: 'Auto Deposit'
            },
            {
                label: 'Review & Approve Checks',
            },
            {
                label: 'Auto-Sign Checks',
            }
        ]
    },
]

export const BillingPlansTableMixin = {
    data() {
        return {
            plans: ['free', 'payg', 'enterprise'],
            selected_plan: false,
            changing_plan: false,

            options: options,
            upsell_modal: false,
            confirm_plan_selected: false,
            scrollingPlansContainer: undefined,
            nav_selected_plan: 'payg' // set default option for tabs bar on mobile devices
        }
    },
    components: {},
    mounted() {},
    computed: {},
    methods: {
        select_plan: function (plan, mobile = false) {
            if (this.plans.indexOf(plan) > -1) {

                this.selected_plan = options[this.plans.indexOf(plan)];
                this.nav_selected_plan = plan;

                //prevent close modal after selecting a plan in mobile devices
                if (!mobile) {
                    this.changing_plan = false;
                }
            }
        },
        scroll_to_card_plan: function (code) {
            this.$refs[code][0].scrollIntoView({behavior: "smooth", inline: "center", block: "nearest"})
            this.nav_selected_plan = code;
        },
        scroll_to_nav_plan: _.debounce(function () {

            const optionsAvailable  = this.$refs['nav-plan-option']
            const element           = this.$refs['card-plans-container']

            let currentTab          = Math.ceil(element.scrollLeft / (element.scrollWidth / optionsAvailable.length))
            let elementTarget       = optionsAvailable[currentTab]

            if (element.offsetWidth >= 768) {

                const maxScrollPossible   = element.scrollWidth - element.clientWidth
                const breakpoints         = [
                    (0),
                    (maxScrollPossible * .10),
                    (maxScrollPossible * .50),
                    (maxScrollPossible),
                ]

                breakpoints.map(function (value, index) {
                    if (element.scrollLeft === value || element.scrollLeft >= value) elementTarget = optionsAvailable[index]
                })

            }

            this.nav_selected_plan = elementTarget.id

            elementTarget.scrollIntoView({behavior: "smooth", inline: "center", block: "nearest"})

        }, 100)
    }
}
